import {get} from '../common/remote/base_api'
export const GetCommisionres = (data) => {
    return get('admin/get-commission-list/', data);
  };